import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const FieldGroup = (props) => {
  const {children, error} = props;
  const className = classnames("form-group", {
    "has-error": Array.isArray(error) ? error && error.length : error,
  });
  return <div className={className}>{children}</div>;
};

FieldGroup.propTypes = {
  children: PropTypes.any,
  error: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.bool,
  ]),
};

export default FieldGroup;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/FieldGroup.js
 **/